import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import Header from './components/Header';
import HomePage from './components/HomePage';
import Footer from './components/Footer';

import './App.css';

function App() {
    return (
        <div className="app__bg">
            <Router>
                <Header />
                <HomePage />
                <Footer />
            </Router>
            
        </div>
    );
}

export default App;
